export class MarketingPopup {
    constructor(public title: string, public description1: string, public description2: string,
        public description3: string, public image1: string, public image2: string, public tooltip: string,
        public functionPackageId: number, public functionPackageName: string,
        public packagePath: string, public dependentFunctionId: number, public dependentFunction2Id: number,public descListHeader?: string, public descList?: string[], public descListFooter?: string) {

    }
}